import React from "react";
import AddToCart from "theme/modules/AddToCart";
import AddMultipleItemsToCart from "theme/modules/AddToCart/AddMultipleItemsToCart";
import { hasGroupedItems } from "theme/modules/ProductView/GroupedItems";
import { defineMessages, useIntl } from "react-intl";
import AddProductToWishlist from "theme/modules/Wishlist/AddProductToWishlist";
import AddProductToRequisitionList from "theme/modules/RequisitionList/AddProductToRequisitionList";

const messages = defineMessages({
  addToCartLabel: {
    id: "modules.ProductView.Synthesis.addToCart",
    defaultMessage: "Add to cart",
  },
  unavailableLabel: {
    id: "modules.ProductView.Synthesis.unavailable",
    defaultMessage: "Currently unavailable",
  },
});

const isInStock = (product) =>
  product.stock !== null && product.stock !== undefined;

export const hasAddToCart = (product) => {
  return hasGroupedItems(product) || isInStock(product);
};

const AddProductToCart = ({
  appearance,
  product,
  onProductAdded,
  selectedGroupedItems,
  selectedOptions,
  selectedCustomOptions,
  selectedBundleOptions,
  withWishlist = true,
}) => {
  const intl = useIntl();
  const withComputedPrice = (product) => ({
    ...product,
    price:
      product.prices && product.prices.finalPrice.priceInclTax.value.amount,
  });

  if (hasGroupedItems(product)) {
    return (
      <AddMultipleItemsToCart
        appearance={appearance}
        onProductAdded={onProductAdded}
        product={withComputedPrice(product)}
        itemList={product.groupedItems.map(({ product }) => {
          return {
            qty:
              selectedGroupedItems.find(({ sku }) => product.sku === sku)
                ?.qty ?? 0,
            product: withComputedPrice(product),
          };
        })}
        label={intl.formatMessage(messages.addToCartLabel)}
        unavailableLabel={intl.formatMessage(messages.unavailableLabel)}
        actions={
          withWishlist !== false && (
            <AddProductToWishlist
              sku={product.sku}
              selectedOptions={selectedOptions}
              selectedCustomOptions={selectedCustomOptions}
              selectedBundleOptions={selectedBundleOptions}
              size="big"
            />
          )
        }
      />
    );
  }

  if (isInStock(product)) {
    return (
      <AddToCart
        appearance={appearance}
        selectedOptions={selectedOptions}
        selectedCustomOptions={selectedCustomOptions}
        selectedBundleOptions={selectedBundleOptions}
        onProductAdded={onProductAdded}
        product={withComputedPrice(product)}
        label={intl.formatMessage(messages.addToCartLabel)}
        unavailableLabel={intl.formatMessage(messages.unavailableLabel)}
        actions={
          <>
            {withWishlist !== false && (
              <AddProductToWishlist
                sku={product.sku}
                selectedOptions={selectedOptions}
                selectedCustomOptions={selectedCustomOptions}
                selectedBundleOptions={selectedBundleOptions}
                size="big"
              />
            )}
            {/* TEMPORARY: overrode this file to add a button to add product to requisition list. By 2.12, an extension point will be added and this override will be removed */}
            <AddProductToRequisitionList
              idPrefix="product-page"
              product={product}
              selectedConfigurableOptions={selectedOptions}
              selectedCustomOptions={selectedCustomOptions}
              selectedBundleOptions={selectedBundleOptions}
              size="big"
            />
          </>
        }
      />
    );
  }

  return null;
};

export default AddProductToCart;
